// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ad833330","453":"077390bd","455":"cf9e775e","814":"aba3a0d5","829":"52193acc"}[chunkId] + ".chunk.js";
};